<template>
  <v-card
    v-bind:class="{ archived: pagebreak.archived, hidden: (!viewArchived && pagebreak.archived), handle: true }"
    style="margin-bottom:20px;cursor:pointer;"
  >
    <v-toolbar
      dense
      flat
      color="rgba(0,0,0,0.09)"
      style="position:relative;"
    >
        <b style="margin-right: 50px;">Page Break</b>
        <v-chip 
          outline
          color="grey"
          small
          v-if="pagebreak.web_only"  
        >
          Web Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="pagebreak.pdf_only"  
        >
          PDF Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="conditional_part"  
        >
          Conditional
        </v-chip>
        <ArchiveButton
          style="float:right;position:absolute;right:15px;top:12px;"
          :archived="pagebreak.archived"
          @restore="restore()"
          @archive="archive()"
        />
    </v-toolbar>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import ArchiveButton from './ArchiveButton'

export default {
  name: 'FormTemplatePageBreak',
  props: [ 'partId', 'newPart' ],
  components: {
    ArchiveButton
  },
  data () {
    return {
      loading: false,
      conditional_part: false
    }
  },
  created () {
    this.conditional_part = (this.pagebreak.conditional_question_id)
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
    ]),
    ...mapState('formtemplate', [
      'viewArchived'
    ]),
    pagebreak: function () {
      return this.partById(this.partId) || this.newPart
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'savePagebreak'
    ]),
    archive () {
      this.loading = true
      this.pagebreak.archived = true
      this.savePagebreak(this.pagebreak)
      .then(pagebreak => {
        this.loading = false
        this.$emit('save', pagebreak)
      })
    },
    restore () {
      this.loading = true
      this.pagebreak.archived = false
      this.savePagebreak(this.pagebreak)
      .then(pagebreak => {
        this.loading = false
        this.$emit('save', pagebreak)
      })
    }
  }
}
</script>

<style scoped>
  .hidden {
    display: none !important;
  }
</style>